import { useState, useEffect, useMemo } from "react";
import { useChatDatabase } from "../../../lib/chatDatabase";

export const useChatList = () => {
    const [addMode, setAddMode] = useState(false);
    const [input, setInput] = useState("");
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [chatToDelete, setChatToDelete] = useState(null);
    
    const { chats, selectChat, deleteChat, fetchChatList } = useChatDatabase();

    useEffect(() => {
        fetchChatList();
    }, [fetchChatList]);

    const filteredChats = useMemo(() => {
        return (chats || []).filter((c) => 
            c.receiverName.toLowerCase().includes(input.toLowerCase())
        );
    }, [chats, input]);

    const handleOpenDeleteModal = (e, chat) => {
        e.stopPropagation(); 
        setChatToDelete(chat);
        setIsDeleteModalOpen(true);
    };

    const handleConfirmDelete = async () => {
        if (!chatToDelete) return;
        try {
            if (deleteChat) {
                await deleteChat(chatToDelete.chatId); 
            }
        } catch (error) {
            console.error("Error when deleting a conversation:", error);
        } finally {
            setIsDeleteModalOpen(false);
            setChatToDelete(null);
        }
    };

    const handleCancelDelete = () => {
        setIsDeleteModalOpen(false);
        setChatToDelete(null);
    };

    const handleSelectChat = (chat) => {
        if (selectChat) {
            const privateKey = localStorage.getItem("myPrivateKey");
            selectChat(chat, privateKey);
        }
    };

    return {
        addMode, setAddMode,
        setInput,
        filteredChats,
        selectChat: handleSelectChat,
        isDeleteModalOpen,
        chatToDelete,
        handleOpenDeleteModal,
        handleConfirmDelete,
        handleCancelDelete
    };
};